import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import { useAuth } from '../app/providers/AuthProvider'

const Settings = () => {
  const { user } = useAuth()
  const [profile, setProfile] = useState(user)
  const [stats, setStats] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    const load = async () => {
      try {
        const [profileResponse, statsResponse] = await Promise.all([
          api.getProfile(),
          api.getStats(),
        ])
        setProfile(profileResponse)
        setStats(statsResponse)
      } catch (err) {
        setError(err.message || 'Failed to load settings')
      }
    }

    load()
  }, [])

  return (
    <div className="space-y-8">
      <div className="flex flex-col gap-2">
        <div className="text-xs uppercase tracking-widest text-slate-500">Settings</div>
        <h1 className="text-3xl font-semibold">Profile and billing</h1>
        <p className="text-slate-600">Manage account details, authentication, and plan settings.</p>
      </div>

      {error ? (
        <div className="rounded-3xl border border-rose-200 bg-rose-50 p-6 text-sm text-rose-600">
          {error}
        </div>
      ) : null}

      <div className="grid gap-6 md:grid-cols-2">
        <div className="rounded-3xl border border-slate-200 bg-white/85 p-6 shadow-sm">
          <div className="text-sm font-semibold">Profile</div>
          <div className="mt-4 space-y-3 text-sm">
            <div className="rounded-2xl border border-slate-200 bg-white px-4 py-3">
              Name: {profile?.name || 'Not set'}
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white px-4 py-3">
              Email: {profile?.email || 'Not set'}
            </div>
          </div>
          <button className="mt-6 rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-ink">
            Update profile
          </button>
        </div>

        <div className="rounded-3xl border border-slate-200 bg-white/85 p-6 shadow-sm">
          <div className="text-sm font-semibold">Plan</div>
          <div className="mt-4 space-y-3 text-sm text-slate-600">
            <div className="flex items-center justify-between">
              <span>Current plan</span>
              <span className="font-semibold text-ink">{stats?.plan || '--'}</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Max projects</span>
              <span className="font-semibold text-ink">{stats?.limits?.maxProjects ?? '--'}</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Warm instances</span>
              <span className="font-semibold text-ink">{stats?.plan === 'PRO' ? 'Yes' : 'No'}</span>
            </div>
          </div>
          <button className="mt-6 w-full rounded-full bg-slate-900 px-4 py-2 text-xs font-semibold text-white">
            Upgrade to Pro
          </button>
        </div>
      </div>

      <div className="rounded-3xl border border-slate-200 bg-white/85 p-6 shadow-sm">
        <div className="text-sm font-semibold">Security</div>
        <p className="mt-2 text-sm text-slate-600">Regenerate API tokens or manage device sessions.</p>
        <div className="mt-4 flex flex-col gap-3 sm:flex-row">
          <button className="rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-ink">
            Rotate tokens
          </button>
          <button className="rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-ink">
            View sessions
          </button>
        </div>
      </div>
    </div>
  )
}

export default Settings
